import { useCallback, useState } from "react";
import {
  USER_PAGE_TOAST,
  resolveUserPageToastMessage,
} from "common/Constants/UserPageToast.constants";

export const hiddenUserPageToast = () => ({
  show: false,
  type: USER_PAGE_TOAST.TYPE_SUCCESS,
  title: "",
  description: "",
});

export const buildUserPageToastSuccess = (description) => ({
  show: true,
  type: USER_PAGE_TOAST.TYPE_SUCCESS,
  title: USER_PAGE_TOAST.TITLE_SUCCESS,
  description,
});

export const buildUserPageToastFailure = (description) => ({
  show: true,
  type: USER_PAGE_TOAST.TYPE_FAILURE,
  title: USER_PAGE_TOAST.TITLE_FAILED,
  description,
});

export const useUserPageToast = () => {
  const [toast, setToast] = useState(hiddenUserPageToast);

  const showSuccess = useCallback((description) => {
    setToast(buildUserPageToastSuccess(description));
  }, []);

  const showFailure = useCallback((description, fallback) => {
    setToast(
      buildUserPageToastFailure(
        resolveUserPageToastMessage(description, fallback)
      )
    );
  }, []);

  const dismissToast = useCallback(() => {
    setToast(hiddenUserPageToast());
  }, []);

  return {
    toast,
    showSuccess,
    showFailure,
    dismissToast,
  };
};
